import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  take: 500,
  tree: [],
  loading: 0,
  datasets: [],
  refreshing: 0,
  dataset: null,
  cacheParams: {},
  lastUpdate: null,
  importables: null,
  withTrashed: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
